const vueAppMagenotApiUrl = import.meta.env.VITE_MAGENTO_API_URL;
const vueAppMaskId = import.meta.env.VITE_APP_MASK_ID;
import { wrapGqlRequest } from "../services/graphqlEndPointCommonSetting/wrapGqlRequest";
import { authHeader } from "./auth";
import { meWrapRequest } from "./nav";

export const registrationService = {
  doResetPassword,
  doConfirmEmail,
  doSignUp,
  doForgotPassword,
};

function handleResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    } else {
      return data;
    }
  });
}

/*function doResetPassword(resetOne) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      email: resetOne.email,
      resetToken: resetOne.token,
      newPassword: resetOne.newPassword,
    }),
  };
  return fetch(
    `${vueAppMagenotApiUrl}/rest/V1/customers/resetPassword`,
    requestOptions
  ).then(handleResponse);
}
*/
async function doResetPassword(resetOne) {
  const query = `
    mutation ResetPassword(
      $email: String!
      $resetPasswordToken: String!
      $newPassword: String!
    ) {
      resetPassword(
        email: $email
        resetPasswordToken: $resetPasswordToken
        newPassword: $newPassword
      )
    }
  `;

  const variables = {
    email: resetOne.email,
    resetPasswordToken: resetOne.token,
    newPassword: resetOne.newPassword,
  };

  const data = await wrapGqlRequest(query, variables, "resetPassword", false);

  return data || null;
}
/*function doForgotPassword(forgot) {
  const requestOptions = {
    method: "PUT",
    headers: {
      "Content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
    },
    body: JSON.stringify({
      email: forgot.email,
      template: "email_reset",
      websiteId: 1,
    }),
  };

  return fetch(
    `${vueAppMagenotApiUrl}/rest/V1/customers/password`,
    requestOptions
  ).then(handleResponse);
}*/

async function doForgotPassword(forgot) {
  const query = `
    mutation RequestPasswordReset($email: String!) {
      requestPasswordResetEmail(email: $email)
    }
  `;

  const variables = {
    email: forgot.email,
  };

  const data = await wrapGqlRequest(
    query,
    variables,
    "requestPasswordResetEmail",
    false,
  );

  return data || null;
}
async function doConfirmEmail() {
  let details = {
    massages: "Your Email id confirm Please login In",
    response: "400",
  };
  return details;
}

// function doSignUp(registration, zinreloRewardsSet, showZinreloRewards) {
//
//     let rewards = "0"
//     let customAttributes = [];
//
//     if (zinreloRewardsSet && zinreloRewardsSet == 'on')
//         rewards = "1";
//
//     if (showZinreloRewards == "disabled")
//         customAttributes = [];
//     else
//         customAttributes = [
//             {
//                 "attribute_code": "feature_rewards",
//                 "value": rewards
//             }];
//
//     const requestOptions = {
//         method: 'POST',
//         headers: {
//             'Content-Type': 'application/json',
//             'Access-Control-Allow-Origin': '*'
//         },
//         body: JSON.stringify({
//             "customer": {
//                 "email": registration.email,
//                 "firstname": registration.firstname,
//                 "lastname": registration.lastname,
//                 "custom_attributes": customAttributes
//             },
//             "password": registration.password,
//             "mask_id": vueAppMaskId
//
//         })
//
//     };
//
//     return fetch(`${vueAppMagenotApiUrl}/rest/all/V1/register-customers`, requestOptions).then(handleResponse);
// }

async function doSignUp(registration, zinreloRewardsSet, showZinreloRewards) {
  let rewards = "0";
  let customAttributes = [];

  if (zinreloRewardsSet && zinreloRewardsSet == "on") rewards = "1";

  if (showZinreloRewards == "disabled") customAttributes = [];
  else
    customAttributes = [
      {
        attribute_code: "feature_rewards",
        value: rewards,
      },
    ];

  const query = `
    mutation CreateCustomer($input: CustomerCreateInput!) {
  createCustomerV2(input: $input) {
    customer {
      email
      firstname
      lastname
      created_at
      date_of_birth
      default_billing
      default_shipping
      allow_remote_shopping_assistance
      is_subscribed
      job_title
      gender
      group {
        uid
      }
      custom_attributes(attributeCodes: [""]) {
        code
        ... on AttributeValue {
          code
          value
        }
        ... on AttributeSelectedOptions {
          selected_options {
            value
            label
          }
        }
      }
      addresses {
        firstname
        lastname
        street
        city
        postcode
        country_code
        region_id
        region {
          region
          region_code
          region_id
        }
        custom_attributesV2 {
          code
          ... on AttributeValue {
            code
            value
          }
          ... on AttributeSelectedOptions {
            selected_options {
              value
              label
            }
          }
        }
      }

      addressesV2(currentPage: 1, pageSize: 5) {
        items {
          firstname
          lastname
          street
          city
          postcode
          country_code
          region_id
          region {
            region
            region_code
            region_id
          }
          custom_attributesV2 {
            code
            ... on AttributeValue {
              code
              value
            }
            ... on AttributeSelectedOptions {
              selected_options {
                value
                label
              }
            }
          }
        }
      }
    }
  }
}
  `;
  const variables = {
    input: {
      email: `${registration?.email}`,
      firstname: `${registration?.firstname}`,
      lastname: `${registration?.lastname}`,
      password: `${registration?.password}`,
      custom_attributes: customAttributes,
    },
  };

  const data = await wrapGqlRequest(query, variables, "createCustomerV2");
  return data?.customer || null;
}

export const doUpdateSubscription = (isSubscribed = true) => {
  const updateCustomerV2Mutation = `
    mutation UpdateCustomer($isSubscribed: Boolean!) {
      updateCustomerV2(
        input: {
          is_subscribed: $isSubscribed
        }
      ) {
        customer {
          date_of_birth
          default_billing
          default_shipping
          email
          firstname
          gender
          is_subscribed
          job_title
          lastname
          middlename
          prefix
        }
      }
    }
  `;

  const variables = {
    isSubscribed,
  };

  return wrapGqlRequest(
    updateCustomerV2Mutation,
    variables,
    "updateCustomerV2",
    false,
  );
};